import { render, staticRenderFns } from "./relatedCompensationOrder.vue?vue&type=template&id=5328150e&scoped=true&"
import script from "./relatedCompensationOrder.vue?vue&type=script&lang=js&"
export * from "./relatedCompensationOrder.vue?vue&type=script&lang=js&"
import style0 from "./relatedCompensationOrder.vue?vue&type=style&index=0&id=5328150e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5328150e",
  null
  
)

export default component.exports